import React, { memo } from 'react'
import Channel from './Channel'

import type { ChannelRowProps } from './types'

const ChannelRow = ({
  data,
  children,
  onFocus,
  onEnterPress,
  index,
  visibility,
  hasFocusedChild,
  hasHiddenListingAtStart,
  autoFocus,
  setAutoFocusEPG,
}: ChannelRowProps) => {
  return (
    <div className="epg__channel-row" style={{ visibility }}>
      <Channel
        data={data}
        index={index}
        onFocus={onFocus}
        onEnterPress={onEnterPress}
        hasFocusedChild={hasFocusedChild}
        hasHiddenListingAtStart={hasHiddenListingAtStart}
        autoFocus={autoFocus}
        setAutoFocusEPG={setAutoFocusEPG}
        focusKey={data.feed_cid}
      />
      {children}
    </div>
  )
}

export default memo(ChannelRow)
